module.exports = __webpack_public_path__ + "static/2-80bec8ad819d739126f8d3b34b802fa3.jpg";